/** True if `node` looks like an ADF `paragraph` node. */
export const isParagraphNode = (
	node: unknown,
): node is { type: 'paragraph'; content?: unknown[] } =>
	typeof node === 'object' && node !== null && (node as { type?: unknown }).type === 'paragraph';
